import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { useStore } from 'hooks/useStore';
import classes from './supportTicketWidget.module.scss';

const SupportTicketWidget = () => {
  const {
    SupportTicketStore: { openChat }
  } = useStore();

  return (
    <>
      <Tooltip target=".support-widget-btn" position="left" />
      <Button
        icon="pi pi-question-circle"
        rounded
        className={`${classes.widgetButton} support-widget-btn`}
        onClick={openChat}
        data-pr-tooltip="Report an Issue"
        aria-label="Report an Issue"
      />
    </>
  );
};

export default observer(SupportTicketWidget);
